// Reducer for supplier store

import {
  GET_SUPPLIER_LIST,
  GET_SUPPLIER_LIST_FAILURE,
  GET_SUPPLIER_LIST_SUCCESS,
  GET_SUPPLIER_DETAILS,
  GET_SUPPLIER_DETAILS_SUCCESS,
  GET_SUPPLIER_DETAILS_FAILURE,
  CREATE_SUPPLIER,
  CREATE_SUPPLIER_SUCCESS,
  CREATE_SUPPLIER_FAILURE,
  UPDATE_SUPPLIER,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER_FAILURE,
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
  GET_SUPPLIER_RECENT_ACTIVITY,
  GET_SUPPLIER_RECENT_ACTIVITY_SUCCESS,
  GET_SUPPLIER_RECENT_ACTIVITY_FAILURE,
  SEARCH_SUPPLIER_NOTE,
  SEARCH_SUPPLIER_NOTE_SUCCESS,
  SEARCH_SUPPLIER_NOTE_FAILURE,
  CREATE_SUPPLIER_NOTE,
  CREATE_SUPPLIER_NOTE_SUCCESS,
  CREATE_SUPPLIER_NOTE_FAILURE,
  DELETE_SUPPLIER_NOTE,
  DELETE_SUPPLIER_NOTE_SUCCESS,
  DELETE_SUPPLIER_NOTE_FAILURE,
  SEARCH_SUPPLIER_ATTACHMENT,
  SEARCH_SUPPLIER_ATTACHMENT_SUCCESS,
  SEARCH_SUPPLIER_ATTACHMENT_FAILURE,
  DELETE_SUPPLIER_ATTACHMENT,
  DELETE_SUPPLIER_ATTACHMENT_SUCCESS,
  DELETE_SUPPLIER_ATTACHMENT_FAILURE,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_SUCCESS,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_FAILURE,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAILURE,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAILURE,
  SEARCH_SUPPLIER_URL_LINK,
  SEARCH_SUPPLIER_URL_LINK_SUCCESS,
  SEARCH_SUPPLIER_URL_LINK_FAILURE,
  GET_SUPPLIER_URL_LINK_DETAILS,
  GET_SUPPLIER_URL_LINK_DETAILS_SUCCESS,
  GET_SUPPLIER_URL_LINK_DETAILS_FAILURE,
  CREATE_SUPPLIER_URL_LINK,
  CREATE_SUPPLIER_URL_LINK_SUCCESS,
  CREATE_SUPPLIER_URL_LINK_FAILURE,
  UPDATE_SUPPLIER_URL_LINK,
  UPDATE_SUPPLIER_URL_LINK_SUCCESS,
  UPDATE_SUPPLIER_URL_LINK_FAILURE,
  DELETE_SUPPLIER_URL_LINK,
  DELETE_SUPPLIER_URL_LINK_SUCCESS,
  DELETE_SUPPLIER_URL_LINK_FAILURE,
  GET_SUPPLIER_URL_LINK_STATUS_LIST,
  GET_SUPPLIER_URL_LINK_STATUS_LIST_SUCCESS,
  GET_SUPPLIER_URL_LINK_STATUS_LIST_FAILURE,
  GET_SUPPLIER_URL_LINK_TYPE_LIST,
  GET_SUPPLIER_URL_LINK_TYPE_LIST_SUCCESS,
  GET_SUPPLIER_URL_LINK_TYPE_LIST_FAILURE,
} from "./actionType";

const initialState = {
  supplierList: [],
  supplierDetails: [],
  supplierCreatedSuccess: [],
  supplierCreatedSuccessLoading: false,
  supplierUpdatedSuccess: [],
  supplierUpdatedSuccessLoading: false,
  supplierDeletedSuccess: [],
  SupplierListLoading: false,
  SupplierRecentActivityLoading: false,
  SupplierRecentActivityList: [],
  supplierNoteListLoading: false,
  supplierNoteList: [],
  createSupplierNoteResponse: [],
  deleteSupplierNoteResponse: [],
  supplierAttachmentListLoading: false,
  supplierAttachmentList: [],
  deleteSupplierAttachmentResponse: [],
  // Supplier Balance Historical
  supplierBalanceHistoricalBySupplier: [],
  supplierBalanceHistoricalBySupplierLoading: false,
  supplierBalanceHistoricalAvailableDates: [],
  supplierBalanceHistoricalAvailableDatesLoading: false,
  supplierBalanceHistoricalSpecificDate: [],
  supplierBalanceHistoricalSpecificDateLoading: false,
  // Supplier Url Links (Task 24318)
  supplierUrlLinkList: [],
  supplierUrlLinkListLoading: false,
  supplierUrlLinkDetails: [],
  createSupplierUrlLinkResponse: [],
  updateSupplierUrlLinkResponse: [],
  deleteSupplierUrlLinkResponse: [],
  supplierUrlLinkStatusList: [],
  supplierUrlLinkTypeList: [],
};

const Supplier = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUPPLIER_LIST:
      return {
        ...state,
        SupplierListLoading: true,
      };
    case GET_SUPPLIER_LIST_SUCCESS:
      return {
        ...state,
        supplierList: action.payload,
        SupplierListLoading: false,
      };
    case GET_SUPPLIER_LIST_FAILURE:
      return {
        ...state,
        SupplierListLoading: false,
      };
    case GET_SUPPLIER_DETAILS:
      return {
        ...state,
      };
    case GET_SUPPLIER_DETAILS_SUCCESS:
      return {
        ...state,
        supplierDetails: action.payload,
      };
    case GET_SUPPLIER_DETAILS_FAILURE:
      return {
        ...state,
      };
    case CREATE_SUPPLIER:
      return {
        ...state,
        supplierCreatedSuccessLoading: true,
      };
    case CREATE_SUPPLIER_SUCCESS:
      return {
        ...state,
        supplierCreatedSuccess: action.payload,
        supplierCreatedSuccessLoading: false,
      };
    case CREATE_SUPPLIER_FAILURE:
      return {
        ...state,
        supplierCreatedSuccessLoading: false,
      };
    case UPDATE_SUPPLIER:
      return {
        ...state,
        supplierUpdatedSuccessLoading: true,
      };
    case UPDATE_SUPPLIER_SUCCESS:
      return {
        ...state,
        supplierUpdatedSuccess: action.payload,
        supplierUpdatedSuccessLoading: false,
      };
    case UPDATE_SUPPLIER_FAILURE:
      return {
        ...state,
        supplierUpdatedSuccessLoading: false,
      };
    case DELETE_SUPPLIER:
      return {
        ...state,
      };
    case DELETE_SUPPLIER_SUCCESS:
      return {
        ...state,
        supplierDeletedSuccess: action.payload,
      };

    case DELETE_SUPPLIER_FAILURE:
      return {
        ...state,
      };
    case GET_SUPPLIER_RECENT_ACTIVITY:
      return {
        ...state,
        SupplierRecentActivityLoading: true,
      };
    case GET_SUPPLIER_RECENT_ACTIVITY_SUCCESS:
      return {
        ...state,
        SupplierRecentActivityList: action.payload,
        SupplierRecentActivityLoading: false,
      };
    case GET_SUPPLIER_RECENT_ACTIVITY_FAILURE:
      return {
        ...state,
        SupplierRecentActivityLoading: false,
      };

    // Supplier Notes
    case SEARCH_SUPPLIER_NOTE:
      return { ...state, supplierNoteListLoading: true };
    case SEARCH_SUPPLIER_NOTE_SUCCESS:
      return {
        ...state,
        supplierNoteListLoading: false,
        supplierNoteList: action.payload,
      };
    case SEARCH_SUPPLIER_NOTE_FAILURE:
      return { ...state, supplierNoteListLoading: false };

    case CREATE_SUPPLIER_NOTE:
      return { ...state };
    case CREATE_SUPPLIER_NOTE_SUCCESS:
      return { ...state, createSupplierNoteResponse: action.payload };
    case CREATE_SUPPLIER_NOTE_FAILURE:
      return { ...state };

    case DELETE_SUPPLIER_NOTE:
      return { ...state };
    case DELETE_SUPPLIER_NOTE_SUCCESS:
      return { ...state, deleteSupplierNoteResponse: action.payload };
    case DELETE_SUPPLIER_NOTE_FAILURE:
      return { ...state };

    // Supplier Attachments
    case SEARCH_SUPPLIER_ATTACHMENT:
      return { ...state, supplierAttachmentListLoading: true };
    case SEARCH_SUPPLIER_ATTACHMENT_SUCCESS:
      return {
        ...state,
        supplierAttachmentListLoading: false,
        supplierAttachmentList: action.payload,
      };
    case SEARCH_SUPPLIER_ATTACHMENT_FAILURE:
      return { ...state, supplierAttachmentListLoading: false };

    case DELETE_SUPPLIER_ATTACHMENT:
      return { ...state };
    case DELETE_SUPPLIER_ATTACHMENT_SUCCESS:
      return { ...state, deleteSupplierAttachmentResponse: action.payload };
    case DELETE_SUPPLIER_ATTACHMENT_FAILURE:
      return { ...state };

    // Supplier Balance Historical — by supplier
    case GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER:
      return { ...state, supplierBalanceHistoricalBySupplierLoading: true };
    case GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_SUCCESS:
      return {
        ...state,
        supplierBalanceHistoricalBySupplierLoading: false,
        supplierBalanceHistoricalBySupplier: action.payload,
      };
    case GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER_FAILURE:
      return { ...state, supplierBalanceHistoricalBySupplierLoading: false };

    // Supplier Balance Historical — available dates
    case GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES:
      return { ...state, supplierBalanceHistoricalAvailableDatesLoading: true };
    case GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS:
      return {
        ...state,
        supplierBalanceHistoricalAvailableDatesLoading: false,
        supplierBalanceHistoricalAvailableDates: action.payload,
      };
    case GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAILURE:
      return {
        ...state,
        supplierBalanceHistoricalAvailableDatesLoading: false,
      };

    // Supplier Balance Historical — whole-book snapshot for one date
    case GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE:
      return { ...state, supplierBalanceHistoricalSpecificDateLoading: true };
    case GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS:
      return {
        ...state,
        supplierBalanceHistoricalSpecificDateLoading: false,
        supplierBalanceHistoricalSpecificDate: action.payload,
      };
    case GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAILURE:
      return { ...state, supplierBalanceHistoricalSpecificDateLoading: false };

    // Supplier Url Links (Task 24318)
    case SEARCH_SUPPLIER_URL_LINK:
      return { ...state, supplierUrlLinkListLoading: true };
    case SEARCH_SUPPLIER_URL_LINK_SUCCESS:
      return {
        ...state,
        supplierUrlLinkListLoading: false,
        supplierUrlLinkList: action.payload,
      };
    case SEARCH_SUPPLIER_URL_LINK_FAILURE:
      return { ...state, supplierUrlLinkListLoading: false };

    case GET_SUPPLIER_URL_LINK_DETAILS:
      return { ...state };
    case GET_SUPPLIER_URL_LINK_DETAILS_SUCCESS:
      return { ...state, supplierUrlLinkDetails: action.payload };
    case GET_SUPPLIER_URL_LINK_DETAILS_FAILURE:
      return { ...state };

    case CREATE_SUPPLIER_URL_LINK:
      return { ...state };
    case CREATE_SUPPLIER_URL_LINK_SUCCESS:
      return { ...state, createSupplierUrlLinkResponse: action.payload };
    case CREATE_SUPPLIER_URL_LINK_FAILURE:
      return { ...state };

    case UPDATE_SUPPLIER_URL_LINK:
      return { ...state };
    case UPDATE_SUPPLIER_URL_LINK_SUCCESS:
      return { ...state, updateSupplierUrlLinkResponse: action.payload };
    case UPDATE_SUPPLIER_URL_LINK_FAILURE:
      return { ...state };

    case DELETE_SUPPLIER_URL_LINK:
      return { ...state };
    case DELETE_SUPPLIER_URL_LINK_SUCCESS:
      return { ...state, deleteSupplierUrlLinkResponse: action.payload };
    case DELETE_SUPPLIER_URL_LINK_FAILURE:
      return { ...state };

    case GET_SUPPLIER_URL_LINK_STATUS_LIST:
      return { ...state };
    case GET_SUPPLIER_URL_LINK_STATUS_LIST_SUCCESS:
      return { ...state, supplierUrlLinkStatusList: action.payload };
    case GET_SUPPLIER_URL_LINK_STATUS_LIST_FAILURE:
      return { ...state };

    case GET_SUPPLIER_URL_LINK_TYPE_LIST:
      return { ...state };
    case GET_SUPPLIER_URL_LINK_TYPE_LIST_SUCCESS:
      return { ...state, supplierUrlLinkTypeList: action.payload };
    case GET_SUPPLIER_URL_LINK_TYPE_LIST_FAILURE:
      return { ...state };

    default:
      return state;
  }
};

export default Supplier;
